/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from "prop-types";
import { Component } from "react";
import Dropdown from "./Dropdown";
import splitComponentProps from "./utils/splitComponentProps";

const propTypes = {
  ...Dropdown.propTypes,

  // Toggle props.
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  title: PropTypes.node.isRequired,
  noCaret: PropTypes.bool,
  isLoading: PropTypes.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: PropTypes.node,
};

class DropdownButton extends Component {
  render() {
    const {
      bsSize, bsStyle, title, children, dropDownMenuClassName, ...props
    } = this.props;

    const [dropdownProps, toggleProps] = splitComponentProps(props, {
      propTypes: ["dropup",
        "id",
        "componentClass",
        "children",
        "disabled",
        "pullRight",
        "open",
        "defaultOpen",
        "onToggle",
        "onSelect",
        "role",
        "rootCloseEvent",
        "onMouseEnter",
        "onMouseLeave",
        "bsClass"],
    });

    return (
      <Dropdown
        {...dropdownProps}
        bsSize={bsSize}
        bsStyle={bsStyle}
      >

        <Dropdown.Toggle
          {...toggleProps}
          bsSize={bsSize}
          bsStyle={bsStyle}
        >
          {title}
        </Dropdown.Toggle>

        <Dropdown.Menu className={dropDownMenuClassName}>
          {children}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

DropdownButton.propTypes = propTypes;

export default DropdownButton;
